/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@mui/material/Box';
import Add from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNew from '@mui/icons-material/OpenInNew';
import PdpQuantityCounter from './pdpQuantityCounter';
import PdpEmail from './pdpEmail';
import PdpPartners from './pdpPartners';
import PdpShopOnline from './pdpShopOnline';
import CustomButton from '../CommonComponents/CustomButton';
import { useNurseryContext } from '../../contexts/NurseryContext';
var classes = {
    notifyMeButton: function (theme) { return ({
        '&.MuiButton-outlined': {
            marginTop: theme.spacing(2.5),
            marginBottom: theme.spacing(0.9),
            width: '100%',
            height: theme.spacing(6),
            textTransform: 'none',
            fontSize: theme.spacing(1.75),
            fontFamily: 'Arial',
            fontWeight: 'bold',
            border: "1px solid ".concat(theme.palette.primary.dark),
            '&:hover': {
                backgroundColor: 'rgba(91, 106, 116, 0.04) !important',
            },
        },
    }); },
};
var PdpHeaderShopify = function (_a) {
    var variants = _a.variants, _b = _a.djangoPk, djangoPk = _b === void 0 ? 0 : _b, onAddToShopifyCart = _a.onAddToShopifyCart, plantTitle = _a.title, partnersData = _a.partnersData, isForSale = _a.isForSale, affiliatedLinks = _a.affiliatedLinks, staticContext = _a.staticContext;
    var nurserySlugContext = useNurseryContext().nurserySlug;
    var nurserySlug = staticContext ? staticContext.nurseries : nurserySlugContext;
    var shopifyProduct = nurserySlug
        ? variants === null || variants === void 0 ? void 0 : variants.filter(function (variant) { return variant.fulfillment_service === nurserySlug; })
        : variants;
    var filteredLinks = nurserySlug
        ? affiliatedLinks.filter(function (item) { return item.nursery.slug === nurserySlug; })
        : affiliatedLinks;
    var selectedServerVariant = shopifyProduct.length > 0
        ? shopifyProduct[0]
        : filteredLinks.length > 0
            ? filteredLinks[0]
            : null;
    var _c = useState(false), isNotifyModal = _c[0], setIsNotifyModal = _c[1];
    var _d = useState(false), openOptions = _d[0], setOpenOptions = _d[1];
    var _e = useState(selectedServerVariant), selectedVariant = _e[0], setSelectedVariant = _e[1];
    var VariantCard = function (_a) {
        var variant = _a.variant;
        var selectedItem = selectedVariant || selectedServerVariant;
        if (selectedItem) {
            var price = variant.price, nursery = variant.nursery;
            var selected = variant.id === selectedItem.id;
            var _b = nursery || {}, shippingInfo = _b.shipping_info, name_1 = _b.name;
            var quantity = 'inventory_quantity' in variant
                ? variant.inventory_quantity
                : variant.quantity;
            var title = 'inventory_quantity' in variant
                ? variant.title
                : variant.size;
            var updatedName = name_1 ? "at ".concat(name_1) : '';
            var quantityText = quantity < 30
                ? "Fewer than ".concat(quantity, " ").concat(updatedName)
                : "".concat(quantity, " ").concat(updatedName);
            var isAffiliated = !('handle' in variant);
            return (React.createElement("div", { className: "variant_container ".concat(selected ? 'selected' : '') },
                React.createElement("div", { role: "button", onClick: function () {
                        setSelectedVariant(variant);
                    }, className: "shopify_variant_card_wrapper ".concat(selected ? 'selected' : '') },
                    React.createElement("div", { className: "shopify_variant_card" },
                        isAffiliated && (!title && !price) ? React.createElement("p", null, name_1) : (React.createElement("p", null,
                            React.createElement("span", null, title),
                            ' ',
                            "|",
                            ' ',
                            React.createElement("strong", null, "$"),
                            React.createElement("strong", null, price))),
                        React.createElement("p", { className: "shipping_info" }, shippingInfo),
                        isAffiliated && (!title && !price) ? React.createElement(React.Fragment, null) : React.createElement("p", { className: "quantity_text" }, quantityText)))));
        }
        return React.createElement(React.Fragment, null);
    };
    var MoreOptions = function () { return (React.createElement("div", { role: "button", onClick: function () { return setOpenOptions(true); }, className: "variant_container" },
        React.createElement("div", { className: "shopify_variant_card_wrapper more_options_container" },
            React.createElement("div", { className: "shopify_variant_card more_options_container " },
                React.createElement("div", { className: "more_options" },
                    React.createElement(Add, null),
                    React.createElement("p", null, "More Options")))))); };
    return (React.createElement("div", { className: "header_shopify" },
        (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 || (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 ? (React.createElement("div", { className: "header_shopify_container" },
            React.createElement("div", { className: "variants_wrapper" },
                (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.length) > 0 && (shopifyProduct === null || shopifyProduct === void 0 ? void 0 : shopifyProduct.map(function (variant) { return (React.createElement(VariantCard, { key: variant.id, variant: variant })); })),
                (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.length) > 0 && (filteredLinks === null || filteredLinks === void 0 ? void 0 : filteredLinks.map(function (link) { return (React.createElement(VariantCard, { key: link.id, variant: link })); })),
                React.createElement(MoreOptions, null)))) : (React.createElement("div", { className: "variants_wrapper notify_container" },
            React.createElement(CustomButton, { onClick: function () {
                    setIsNotifyModal(true);
                    setOpenOptions(true);
                }, variant: "outlined", color: "primary", buttonClassSX: classes.notifyMeButton, buttonText: "Notify me" }),
            (partnersData === null || partnersData === void 0 ? void 0 : partnersData.length) > 0 && React.createElement(MoreOptions, null))),
        (selectedVariant || selectedServerVariant) && isForSale && ('handle' in (selectedVariant || selectedServerVariant)) && (React.createElement(PdpQuantityCounter, { selectedVariant: (selectedVariant || selectedServerVariant), djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart })),
        ((selectedVariant || selectedServerVariant) && !('handle' in (selectedVariant || selectedServerVariant)) && (selectedVariant || selectedServerVariant).sale_url)
            && (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: (selectedVariant || selectedServerVariant).sale_url },
                React.createElement("button", { style: {
                        width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 16,
                    }, type: "button", className: "btn primary ", onClick: function () { return gtag('event', 'buy_from_nursery'); } },
                    "Buy Direct from Nursery",
                    ' ',
                    React.createElement(OpenInNew, { sx: { padding: 0, marginLeft: 2 } })))),
        React.createElement(Modal, { onClose: function () {
                setIsNotifyModal(false);
                setOpenOptions(false);
            }, open: openOptions },
            React.createElement(Box, { className: "options_modal ".concat(isNotifyModal ? 'notify_me' : '') },
                React.createElement("button", { type: "button", onClick: function () {
                        setIsNotifyModal(false);
                        setOpenOptions(false);
                    }, className: "close_btn" },
                    React.createElement(CloseIcon, null)),
                React.createElement(Box, { className: "options_modal_wrapper" },
                    !isNotifyModal
                        && (React.createElement("h1", null,
                            "Find",
                            ' ',
                            plantTitle)),
                    ((isForSale || (affiliatedLinks === null || affiliatedLinks === void 0 ? void 0 : affiliatedLinks.length) > 0) && !isNotifyModal) && (React.createElement(PdpShopOnline, { djangoPk: djangoPk, onAddToShopifyCart: onAddToShopifyCart, variants: variants.filter(function (item) { return item.available; }), affiliatedLinks: affiliatedLinks })),
                    (partnersData.length > 0 && !isNotifyModal)
                        && React.createElement(PdpPartners, { data: partnersData }),
                    React.createElement("div", { className: "pdp_email_modal" },
                        React.createElement("div", { className: "modal_item_container" },
                            React.createElement(PdpEmail, { isNotifyModal: isNotifyModal, plantId: djangoPk, plantName: plantTitle, closeModal: function () { setIsNotifyModal(false); setOpenOptions(false); } }))))))));
};
export default withRouter(PdpHeaderShopify);
